export const parseSecurableTypes = (data: unknown): string[] => {
  if (!data || typeof data !== 'object') {
    return [];
  }

  const first = Object.values(data as Record<string, unknown>)[0];

  return Array.isArray(first) ? first : [];
};

export type SecurableTypesPayload = {
  securableTypes: string[];
};

/** Securable type codes for a tree node, tied to the node id that was fetched. */
export type LoadedSecurableTypes = {
  treeItem: string;
  securableTypes: string[];
};

export const isSecurableTypesPayload = (value: unknown): value is SecurableTypesPayload =>
  Boolean(
    value &&
      typeof value === 'object' &&
      'securableTypes' in value &&
      Array.isArray((value as SecurableTypesPayload).securableTypes)
  );
